import axios from "axios";

export const downloadFile = async (filename: string, fileKey: string) => {
  const filedata = await axios({
    method: "POST",

    url: `api/template/downLoad/${fileKey}`,
    responseType: "blob",
  });
  const blob = URL.createObjectURL(new Blob([filedata.data]));
  const el = document.createElement("a");
  el.setAttribute("download", filename);
  el.href = blob;
  document.body.appendChild(el);
  el.click();
  document.body.removeChild(el);
};
export const downloadTableFile = async (filename: string, fileKey: string) => {
  const filedata = await axios({
    method: "GET",

    url: `api/file/downfile/${fileKey}`,
    responseType: "blob",
  });
  const blob = URL.createObjectURL(new Blob([filedata.data]));
  const el = document.createElement("a");
  el.setAttribute("download", filename);
  el.href = blob;
  document.body.appendChild(el);
  el.click();
  document.body.removeChild(el);
};

export const downloadByUrl = async (filename: string, id: string) => {
  const filedata = await axios({
    method: "GET",
    url: `/api/file/downfile/${id}`,
    responseType: "blob",
  });
  const blob = URL.createObjectURL(new Blob([filedata.data]));
  const el = document.createElement("a");
  el.setAttribute("download", filename);
  el.href = blob;
  document.body.appendChild(el);
  el.click();
  document.body.removeChild(el);
};
